enum DealsListViewType {
  LIST = 'list',
  TILES = 'tiles',
}

export default DealsListViewType;
